import { render, staticRenderFns } from "./TintCategoryForm.vue?vue&type=template&id=43c701bc&"
import script from "./TintCategoryForm.vue?vue&type=script&lang=js&"
export * from "./TintCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./TintCategoryForm.vue?vue&type=style&index=0&id=43c701bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports